import TrackingScreen from '.';
import TrackScreen from './track';

const routes = [
  {
    path: '/',
    component: TrackingScreen,
  },
  {
    path: '/track/*',
    component: TrackScreen,
  },
];

export default routes;
